<template>
    <b-card class="sa-card" header-tag="header" footer-tag="footer" title="">
        <template #header>
            <div class="d-flex justify-content-between align-items-center">
                <h5 class="mt-0 mb-0">
                    <span>
                        <i class="fas fa-notes-medical"></i>
                        {{ titolo }}
                    </span>
                </h5>

                <b-button size="sm" variant="success" :disabled="!currentIdPaziente" @click="onAggiungiPatologia">
                    <b-icon icon="plus"></b-icon>
                    Aggiungi
                </b-button>
            </div>
        </template>

        <div v-if="loading" class="text-center py-3">
            <b-spinner small variant="info"></b-spinner>
            Caricamento patologie...
        </div>

        <template v-else>
            <ul v-if="patologie.length > 0" class="list-unstyled mb-3">
                <li v-for="item in patologie" :key="item.id" class="d-flex justify-content-between align-items-start border-bottom py-2">
                    <div class="flex-grow-1">
                        <div>
                            <strong>{{ getDescrizioneIcdix(item) }}</strong>
                        </div>

                        <div class="text-danger">
                            Dal {{ formatDate(item.dataInizio) }}<template v-if="item.dataChiusura"> al {{ formatDate(item.dataChiusura) }}</template>
                        </div>

                        <i v-if="item.note" class="blockquote-footer">{{ item.note }}</i>
                    </div>

                    <b-button variant="outline-info" v-b-tooltip.hover title="Visualizza patologia" @click="onVisualizzaPatologia(item)">
                        <b-icon icon="eye"></b-icon>
                    </b-button>

                    <b-button variant="outline-warning" v-b-tooltip.hover title="Modifica patologia" @click="onModificaPatologia(item)">
                        <b-icon icon="pencil"></b-icon>
                    </b-button>
                </li>
            </ul>

            <div v-else class="text-center text-muted py-3">Nessuna patologia presente.</div>
        </template>

        <!-- Modale visualizzazione patologia -->
        <b-modal ref="modalVisualizzaPatologia" title="Visualizza Patologia" size="lg" centered scrollable hide-footer @hidden="onChiudiVisualizzazione">
            <div v-if="patologiaVisualizzata">
                <b-row>
                    <b-col cols="12" sm="4">
                        <label class="sa-label-data">Codice ICD-IX</label>
                        <p class="sa-data">{{ patologiaVisualizzata.codiceIcdix || "---" }}</p>
                    </b-col>
                    <b-col cols="12" sm="8">
                        <label class="sa-label-data">Descrizione ICD-IX</label>
                        <p class="sa-data">{{ patologiaVisualizzata.descrizioneIcdix || "---" }}</p>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="sa-label-data">Data Inizio</label>
                        <p class="sa-data">{{ formatDate(patologiaVisualizzata.dataInizio) }}</p>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="sa-label-data">Data Chiusura</label>
                        <p class="sa-data">{{ formatDate(patologiaVisualizzata.dataChiusura) }}</p>
                    </b-col>
                    <!--        <b-col cols="12" sm="4">
                        <label class="sa-label-data">Stato</label>
                        <p class="sa-data">{{ patologiaVisualizzata.stato || "---" }}</p>
                    </b-col> -->
                    <b-col cols="12">
                        <label class="sa-label-data">Note</label>
                        <p class="sa-data" style="white-space: pre-wrap">{{ patologiaVisualizzata.note || "---" }}</p>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <!-- Modale inserimento e modifica patologia -->
        <b-modal ref="modalFormPatologia" :title="titoloModalPatologia" size="lg" centered no-close-on-backdrop @hidden="onChiudiForm">
            <b-row>
                <b-col cols="12" class="mb-2">
                    <label class="sa-label-data">Patologia ICD-IX</label>
                    <b-input-group>
                        <b-form-input :value="getDescrizioneIcdix(jsonData)" placeholder="Selezionare una patologia ICD-IX" readonly></b-form-input>
                        <b-input-group-append>
                            <b-button variant="outline-primary" title="Cerca diagnosi ICD9" aria-label="Cerca diagnosi ICD9" @click="onClickSearchIcdix">
                                <b-icon icon="search"></b-icon>
                                Cerca ICD9
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col cols="12" sm="6" class="mb-2">
                    <label class="sa-label-data">Data Inizio</label>
                    <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="jsonData.dataInizio" type="date"></date-picker>
                </b-col>
                <b-col cols="12" sm="6" class="mb-2">
                    <label class="sa-label-data">Data Chiusura</label>
                    <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="jsonData.dataChiusura" type="date"></date-picker>
                </b-col>
                <b-col cols="12">
                    <label class="sa-label-data">Note</label>
                    <b-form-textarea v-model="jsonData.note" rows="3" max-rows="6"></b-form-textarea>
                </b-col>
            </b-row>

            <template #modal-footer>
                <b-button variant="outline-danger" :disabled="saving" @click="onAnnullaForm">Annulla</b-button>
                <b-button variant="outline-success" :disabled="saving || !isFormValido" @click="onSalvaPatologia">
                    <b-spinner v-if="saving" small></b-spinner>
                    Salva
                </b-button>
            </template>
        </b-modal>

        <diagnosi-icd-ix-component v-show="false" ref="cmpDiagnosiIcdIx" @onModalClose="onModalDiagnosiIcdIxClose"></diagnosi-icd-ix-component>
    </b-card>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import DiagnosiIcdIxComponent from "../../utility/components/DiagnosiIcdIxComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin.js";

export default {
    components: { DatePicker, DiagnosiIcdIxComponent },
    mixins: [UtilityMixin],

    props: {
        idPaziente: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            pathResource: "/pazientipatologie",
            patologie: [],
            loading: false,
            saving: false,
            patologiaVisualizzata: null,
            jsonData: this.getFormVuoto(),
        };
    },

    computed: {
        titolo() {
            return "Patologie";
        },

        currentIdPaziente() {
            return this.idPaziente || this.$route.query.idPaziente || this.$route.params.id || null;
        },

        titoloModalPatologia() {
            return this.jsonData.id ? "Modifica Patologia" : "Aggiungi Patologia";
        },

        isFormValido() {
            return !!(this.jsonData.codiceIcdix && this.jsonData.descrizioneIcdix && this.jsonData.dataInizio);
        },
    },

    watch: {
        currentIdPaziente: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.loadPatologie();
                } else {
                    this.patologie = [];
                }
            },
        },
    },

    methods: {
        getFormVuoto() {
            return {
                id: null,
                codiceIcdix: null,
                descrizioneIcdix: null,
                dataInizio: new Date().getTime(),
                dataChiusura: null,
                note: "",
                stato: 1,
            };
        },

        loadPatologie() {
            if (!this.currentIdPaziente) {
                this.patologie = [];
                return;
            }

            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;

            me.loading = true;

            axios
                .get(link, { params: { idPaziente: me.currentIdPaziente } })
                .then((response) => {
                    let data = response.data.data;

                    me.patologie = Array.isArray(data) ? data : data && Array.isArray(data.list) ? data.list : [];
                })
                .catch((error) => {
                    me.patologie = [];

                    let messaggio = error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : "Errore durante il caricamento delle patologie.";

                    me.$bvToast.toast(messaggio, {
                        title: "ATTENZIONE",
                        variant: "danger",
                        solid: true,
                    });
                })
                .finally(() => {
                    me.loading = false;
                });
        },

        onAggiungiPatologia() {
            if (!this.currentIdPaziente) {
                return;
            }

            this.jsonData = this.getFormVuoto();

            this.$nextTick(() => {
                this.$refs.modalFormPatologia.show();
            });
        },

        onVisualizzaPatologia(item) {
            this.patologiaVisualizzata = Object.assign({}, item);

            this.$nextTick(() => {
                this.$refs.modalVisualizzaPatologia.show();
            });
        },

        onModificaPatologia(item) {
            if (!this.currentIdPaziente) {
                return;
            }
            this.loadPatologia(item.id);
            /*    this.jsonData = {
                id: item.id,
                codiceIcdix: item.codiceIcdix || null,
                descrizioneIcdix: item.descrizioneIcdix || null,
                dataInizio: item.dataInizio || null,
                dataChiusura: item.dataChiusura || null,
                note: item.note || "",
                stato: item.stato || null,
            }; */

            //      this.$nextTick(() => {
            this.$refs.modalFormPatologia.show();
            //        });
        },
        loadPatologia(id) {
            this.loadDataResources(this.pathResource + "/" + id, {}, this.resulResponsePatologia, null);
        },
        resulResponsePatologia(response) {
            this.jsonData = response.data.data;
        },

        onClickSearchIcdix() {
            this.$refs.cmpDiagnosiIcdIx.onClickBtnRicercaIcdIx();
        },

        onModalDiagnosiIcdIxClose(selectedElement) {
            let diagnosi = selectedElement && selectedElement[0] && selectedElement[0][0];

            if (!diagnosi || !diagnosi.codiceIcdix) {
                return;
            }

            this.$set(this.jsonData, "codiceIcdix", diagnosi.codiceIcdix);
            this.$set(this.jsonData, "descrizioneIcdix", diagnosi.descrizioneIcdix);
        },

        onSalvaPatologia() {
            if (!this.isFormValido || !this.currentIdPaziente) {
                return;
            }

            let me = this;
            me.saving = true;
            // /*         let link = process.env.VUE_APP_PATH_API + me.pathResource;
            //         let body = {
            //             idAnagrafica: me.currentIdPaziente,
            //             codiceIcdix: me.jsonData.codiceIcdix,
            //             descrizioneIcdix: me.jsonData.descrizioneIcdix,
            //             dataInizio: me.jsonData.dataInizio,
            //             dataChiusura: me.jsonData.dataChiusura,
            //             note: me.jsonData.note,
            //             stato: me.jsonData.stato,
            //         };
            //         let request = null; */
            me.jsonData.idAnagrafica = me.currentIdPaziente;
            UtilityMixin.methods.saveResource(this.pathResource, me.jsonData, me.resultSaveResponse, me.resultSaveError);
            /*   if (me.jsonData.id) {
                body.id = me.jsonData.id;
                body.stato = me.jsonData.stato;
                request = axios.put(link + "/" + me.jsonData.id, JSON.stringify(me.jsonData));
            } else {
                request = axios.post(link, JSON.stringify(me.jsonData));
            } */

            // request
            //     .then((response) => {})
            //     .catch((error) => {
            //         const messaggio = error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : "Errore durante il salvataggio della patologia.";

            //         me.$bvToast.toast(messaggio, {
            //             title: "ATTENZIONE",
            //             variant: "danger",
            //             solid: true,
            //         });
            //     })
            //     .finally(() => {
            //         me.saving = false;
            //     });
        },
        resultSaveResponse() {
            let me = this;
            me.$refs.modalFormPatologia.hide();
            me.loadPatologie();

            let messaggio = "Patologia salvata correttamente.";

            me.$bvToast.toast(messaggio, {
                title: "",
                variant: "success",
                solid: true,
            });
            me.saving = false;
        },
        resultSaveError(error) {
            let me = this;

            let messaggio = error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : "Errore durante il salvataggio della patologia.";

            me.$bvToast.toast(messaggio, {
                title: "ATTENZIONE",
                variant: "danger",
                solid: true,
            });
            me.saving = false;
        },

        onAnnullaForm() {
            this.$refs.modalFormPatologia.hide();
        },

        onChiudiForm() {
            this.jsonData = this.getFormVuoto();
        },

        onChiudiVisualizzazione() {
            this.patologiaVisualizzata = null;
        },

        getDescrizioneIcdix(item) {
            if (!item || !item.codiceIcdix) {
                return "";
            }

            return "(" + item.codiceIcdix + ") " + (item.descrizioneIcdix || "");
        },

        formatDate(value) {
            if (value) {
                return moment(new Date(value)).format("DD-MM-YYYY");
            }

            return "---";
        },
    },
};
</script>

<style scoped>
.sa-page-paziente-terapia-attiva .card-body {
    overflow: auto;
}
</style>
